__turbopack_context__.v({
  "className": "exposure_582d78-module__NBWgJW__className",
  "variable": "exposure_582d78-module__NBWgJW__variable",
});
